<template>
  <div class="msg" v-show="showMsg">
    <div class="desc">
      <img src="../../assets/img/msg.png" alt="">
      <p>
        您目前还不是黑卡PLUS会员，无法享受会员专属优惠价格，以下商品均为原价。
        <!-- 即刻享受会员优惠价请点击“立即办理” -->
      </p>
    </div>
    <!-- <div class="functional-btn">
      <button @click="$router.push({name: 'memberCenter'})" class="deal-with">立即办理</button>
      <button class="ignore" @click="closeMsg">忽略</button>
    </div> -->
  </div>
</template>

<script>
export default {
  name: 'msg',
  model: {
    prop: 'showMsg',
    event: 'change'
  },
  props: {
    showMsg: {
      type: Boolean
    }
  },
  methods: {
    closeMsg () {
      this.$emit('close-msg', false)
    }
  }
}
</script>

<style lang="less" scoped>
.msg {
  // position: fixed;
  // z-index: 999;
  // top: 0.88rem;
  padding: 0.45rem 0.4rem;
  background-color: #FFFBF4;
  .desc {
    img {
      width: 0.36rem;
      height: 0.4rem;
      padding-right: 0.3rem;
    }
    .flex-between;
    color: #F36051;
    font-size: @fz26;
  }
  .functional-btn {
    width: 100%;
    .flex-center;
    justify-content: space-around;
    margin-top: 0.2rem;
    button {
      width: 2.5rem;
      height: 0.63rem;
      font-size: 0.28rem;
      border-radius: 30px;
      box-sizing: border-box;
    }
    .deal-with {
      background-color: #F36051;
      color: #fff;
    }
    .ignore {
      color: @c80;
      border: 0.5px solid #979797;
    }
  }
}
</style>
